<template>
  <div>You should have an <code>inline-template</code> directive on the component</div>
</template>
<script>
import initializeArticle from "../../../../article-editor-init";

export default {
  props: ['agreement_type', 'agreement_name', 'agreement_templates'],
  articleEditor: null,

  data() {
    return {
      name: this.agreement_name,
      agreementType: this.agreement_type,
      licenseTemplate: null
    }
  },

  mounted() {
    this.articleEditor = initializeArticle(".redactor-content-vue")
  },

  destroy () {
    if (this.articleEditor) {
      this.articleEditor.stop();
      this.articleEditor = null
    }
  },

  watch: {
    licenseTemplate(val) {
      if (val && val.length > 0) {
        const template = this.agreement_templates[val].text
        if (this.articleEditor) {
          this.articleEditor.editor.setContent({html: template})
        }
      }
    },

    agreementType(val) {
      if (val === 'rights_managed') {
        this.name = "Custom Rights Managed"
      } else {
        this.name = "Custom Royalty-Free"
      }
    },
  },
}
</script>